import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=315bccf2&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315bccf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315bccf2')) {
      api.createRecord('315bccf2', component.options)
    } else {
      api.reload('315bccf2', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=315bccf2&scoped=true&", function () {
      api.rerender('315bccf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2C6swR9VoxwtM/JS/comp/Voucher-Unit.vue"
export default component.exports